import { ContentReducerCreator } from '../types';

const clearRecordingsReducer = (create: ContentReducerCreator) => {
  return create.reducer((state) => {
    state.recordings = null;
  });
};

export default clearRecordingsReducer;
